export default __webpack_public_path__ + "static/media/globe.fa47d982.svg";